(function (factory) {
  const estimator = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = estimator;
  if (typeof document !== 'undefined') estimator.start();
})(function () {
  'use strict';
  const data = window.SLDEstimatorData;
  const product = data.products.stakeSack;
  const controls = data.productControls.stakeSack;
  const closure = data.shared.components.sackClosure;
  const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
  const prompt = 'Select your fabric, width, length, and reinforced bottom option to see the estimated weight.';

  function selections(scope) {
    const selected = Object.create(null);
    for (const element of scope.querySelectorAll('select')) {
      const label=Object.keys(product.FIELD_LABELS).find(key=>key.replace(/\s+/g,' ').trim()===String(element.labels&&element.labels[0]&&element.labels[0].textContent||'').replace(/\s+/g,' ').trim());
      if (!own(product.FIELD_LABELS, label)) continue;
      const field = product.FIELD_LABELS[label];
      selected[field] = own(selected, field) ? null : element.value;
    }
    return selected;
  }

  function estimate(choice) {
    if (choice.Fabric === product.CUSTOM_FABRIC) return {manual:true, message:'Custom fabric requires a manual weight estimate. Please contact me before ordering.'};
    const bottom = choice.Bottom === undefined ? 'No' : choice.Bottom;
    if (!own(product.FABRICS, choice.Fabric) || !own(product.WIDTHS, choice.Width) || !own(product.LENGTHS, choice.Length) || !own(product.BOTTOM, bottom)) return null;
    const width = product.WIDTHS[choice.Width];
    const length = product.LENGTHS[choice.Length];
    if (width < controls.minWidth || width > controls.maxWidth || length < controls.minLength || length > controls.maxLength) return null;
    const rawWidth = width * controls.rawWidthMultiplier + controls.rawWidthExtra;
    const rawLength = length + controls.rawLengthExtra;
    const body = rawWidth * rawLength / 1296 * product.FABRICS[choice.Fabric].planningDensity;
    const small = width <= controls.smallClosureMaxWidth;
    const drawstring = (rawWidth + controls.drawstringExtra) * (small ? closure.lightDrawstringPerInch : closure.catchAllDrawstringPerInch) * controls.drawstringCount;
    const lock = (small ? closure.tinyCordLock : closure.mediumCordLock) * controls.cordLockCount;
    const reinforcement = product.BOTTOM[bottom] ? (rawWidth - controls.reinforcement.lengthDeduction) * controls.reinforcement.weightPerInch : 0;
    const finished = body + drawstring + lock + reinforcement + controls.constructionAllowance;
    return {rawWidth, rawLength, body, drawstring, lock, reinforcement, finished, grams:finished * controls.gramsPerOunce};
  }

  function format(result) {
    return result.finished.toFixed(controls.displayOunceDecimals) + ' oz / ' + Math.round(result.grams) + ' g';
  }

  function start() {
    const root = document.querySelector('[data-sld-stake-sack-estimator]');
    if (!root) return;
    const scope = root.closest('product-info') || document;
    const results = root.querySelector('[data-sld-estimator-results]');
    const message = root.querySelector('[data-sld-estimator-message]');
    const weight = root.querySelector('[data-sld-weight-stake-sack]');
    function text(element, value) {
      if (element && element.textContent !== value) element.textContent = value;
    }
    function calculate() {
      const result = estimate(selections(scope));
      const valid = result && !result.manual;
      if (results) results.hidden = !valid;
      text(message, valid ? '' : result && result.manual ? result.message : prompt);
      text(weight, valid ? format(result) : '');
    }
    let timer;
    const queue = () => { clearTimeout(timer); timer = setTimeout(calculate, 75); };
    scope.addEventListener('change', queue, true);
    scope.addEventListener('input', queue, true);
    new MutationObserver(mutations => {
      if (mutations.some(mutation => !root.contains(mutation.target))) queue();
    }).observe(scope, {subtree:true, childList:true, attributes:true, attributeFilter:['value','checked','selected']});
    calculate();
  }
  return {estimate, selections, format, start};
});
